import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const GetMenus = urlConfig.GetMenus;
const GetFoldersById = urlConfig.GetFoldersById;

export const getMenuData = async (params: any) => {
  try {
    const response = await postCall(GetMenus, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getFoldersData = async (params: any) => {
  try {
    const response = await postCall(GetFoldersById, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};   


export const menuStatusChange = async (params: any) => {
  try {
    const response = await postCall(urlConfig.MenuStatusChange, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const menuItemInsertUpdate = async (params: any) => {
  try {
    const response = await postCall(urlConfig.MenuItemInsertUpdate, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
